module.exports = __webpack_public_path__ + "static/nuts-1ada9f598ed5693c5a917b5fc862942c.jpg";